// Runtime configuration. The API lives on the same host as the SPA (the .NET
// backend serves both), so we derive the API base URL from the current origin.

const config = {
    apiUrl: `${window.location.protocol}//${window.location.host}/`,
    // Production reCAPTCHA v2 site key is the default; override locally via
    // VITE_RECAPTCHA_SITE_KEY in .env.development (the official test key).
    recaptchaSiteKey:
        import.meta.env.VITE_RECAPTCHA_SITE_KEY || '6Les4ioaAAAAAAE027GKw8fHo8-7doFMhfZ1FMIX',
};

export default config;
